export default __webpack_public_path__ + "static/media/help.456a8734.svg";